import React from "react";
import { Link } from "react-router-dom";
import { ROUTES } from "constants/index";
import { Button } from "components/ui";
import heroIllustration from "assets/images/website/features-design.svg";

const Hero: React.FC = () => {
  return (
    // <section className="relative overflow-hidden">
    //   <div className="absolute inset-0  dark:from-secondary-900 dark:via-secondary-800 dark:to-secondary-900" />
    //   <div className="absolute -right-16 -top-16 h-96 w-96 rounded-full bg-primary-400/20 blur-3xl" />
    //   <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-[28rem] w-[28rem] rounded-full bg-primary-300/20 blur-3xl" />
    //   <div className="mx-auto my-0 max-w-7xl px-4 py-16 md:p-[70px] text-gray-900">
    //     <div className="flex w-full flex-col items-center justify-center -mb-14 md:-mb-[96px]">
    //       <div className="flex flex-col lg:justify-between items-center gap-0 md:gap-2">
    //         <div className="flex flex-col gap-2 items-center text-[14px] leading-[19px] font-[450]">
    //           <div>
    //             <h1 className="flex flex-col items-cente text-center heading text-4xl sm:text-5xl md:text-7xl lg:text-6xl font-extrabold tracking-tight text-secondary-900 dark:text-white">
    //               Your Qcard
    //               <span className="mt-2 sm:mt-6 text-secondary-700 dark:text-secondary-300 text-base sm:text-3xl">
    //                 Your Digital Business Card.
    //               </span>
    //             </h1>
    //           </div>
    //         </div>
    //         <div className="pt-[64px]">
    //           <img
    //             src={heroIllustration}
    //             alt="ID card dashboard illustration"
    //             className="h-full w-full object-cover mx-auto"
    //             width="902"
    //             height="249"
    //           />
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </section>
    <section className="relative overflow-hidden pt-24 pb-20 lg:pt-32 lg:pb-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col lg:flex-row items-center dark:from-secondary-900 dark:via-secondary-800 dark:to-secondary-900">
            <div className="lg:w-1/2 text-center lg:text-left mb-12 lg:mb-0">
                <h1 className="text-5xl lg:text-7xl font-extrabold text-primary-900 leading-tight mb-6">
                    Digital Identity <br/>
                    <span className="text-secondary-600">Reimagined.</span>
                </h1>
                <p className="text-xl text-primary-600 mb-8 max-w-2xl mx-auto lg:mx-0">
                    The most secure way to issue, manage, and verify professional ID cards for your entire workforce. Ditch the plastic, embrace the digital.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                    <Link to={`${ROUTES.PRICING}?freeTrial=true`} className="bg-primary-600 text-white px-8 py-4 rounded-xl text-lg font-bold hover:bg-primary-700 transition-all inline-block text-center">
                        Start Free Trial
                    </Link>
                    <button className="bg-white/70 border-2 border-primary-200 text-primary-700 px-8 py-4 rounded-xl text-lg font-bold hover:bg-gray-50 transition-all">
                        Watch Demo
                    </button>
                </div>
            </div>
            
            <div className="lg:w-1/2 relative">
                <div className="relative z-10 mx-auto w-64 h-96 bg-white rounded-[2rem] shadow-2xl border-[8px] border-primary-700 overflow-hidden transform rotate-2 hover:rotate-0 transition-transform duration-500">
                    <div className="bg-primary-500 h-24 p-4 flex justify-center">
                        <div className="w-16 h-16 bg-white rounded-full border-4 border-white -mb-8 mt-4 shadow-md flex items-center justify-center">
                             <img src="https://api.dicebear.com/7.x/avataaars/svg?seed=Felix" alt="User" className="rounded-full"/>
                        </div>
                    </div>
                    <div className="pt-12 px-6 text-center">
                        <h3 className="font-bold text-lg">Alex Johnson</h3>
                        <p className="text-blue-600 text-xs font-semibold uppercase tracking-widest mb-4">Senior Architect</p>
                        
                        <div className="bg-gray-100 p-4 rounded-xl mb-4">
                            <div className="w-24 h-24 mx-auto bg-white p-2 rounded-lg">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <path d="M3 3h4v4H3zM17 3h4v4h-4zM3 17h4v4H3zM14 14h7v7h-7zM7 7h10M7 17h3M14 3v7M14 17h3"></path>
                                </svg>
                            </div>
                            <p className="text-[10px] text-gray-400 mt-2">ID: Q-99281-XC</p>
                        </div>
                        <div className="text-[10px] flex justify-between text-gray-500">
                            <span>Issued: Jan 2024</span>
                            <span>Exp: Jan 2026</span>
                        </div>
                    </div>
                </div>
                <div className="absolute -top-10 -right-10 w-64 h-64 bg-blue-100 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-pulse"></div>
                <div className="absolute -bottom-10 -left-10 w-64 h-64 bg-indigo-100 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-pulse animation-delay: 2s"></div>
            </div>
        </div>
    </section>
  );
};

export default Hero;
